import {Module} from '@dms/api/shared';
import {moduleKeys} from '@dms/config';
import {featureFlags} from '@dms/feature-flags';
import {telephonyRoutes} from '@dms/routes';
import {permissions} from '@dms/shared';

import {TelephonyCallDetail} from './pages/TelephonyCallDetail/TelephonyCallDetail';
import {TelephonyCallList} from './pages/TelephonyCallList/TelephonyCallList';

/**
 * Stored telephony calls: the call list and the call detail page. Everyone holding `CALL / READ`
 * sees every stored call; the module is a PoC behind the telephony flag.
 */
export const TelephonyModule: Module = {
  id: moduleKeys.telephony,
  requiredFeatureFlag: featureFlags.CORE_TELEPHONY,
  requiredPermission: permissions.callRead,
  layoutProps: {
    title: 'page.settings.telephony.title',
    icon: 'communication/call',
  },
  routerProps: {
    path: telephonyRoutes.calls,
  },
  content: [
    {
      id: 'telephony.calls',
      routerProps: {
        path: telephonyRoutes.calls,
        element: <TelephonyCallList />,
      },
      layoutProps: {
        title: 'page.telephony.thread.callsFilter',
        icon: 'communication/call',
      },
    },
    {
      id: 'telephony.callDetail',
      routerProps: {
        path: telephonyRoutes.callDetail,
        element: <TelephonyCallDetail />,
      },
    },
  ],
};
